import { TrendingUp } from "lucide-react";

const LINE = "SAIL — Mission ₹500 Crores from Digitalisation";
const REPEATS = [0, 1, 2];

const SKIN = {
  app: {
    wrap: "border-t border-primary/35 bg-primary/[0.08]",
    badge: "bg-primary text-primary-foreground",
    dot: "bg-primary-foreground",
    text: "text-foreground",
    accent: "text-primary",
  },
  dark: {
    wrap: "border-y border-[color:var(--acc-ring)] bg-[color:var(--acc-tint)]",
    badge: "bg-[color:var(--acc-mid)] text-white",
    dot: "bg-white",
    text: "text-zinc-100",
    accent: "text-[color:var(--acc-soft)]",
  },
};

const Track = ({ skin, hidden }) => (
  <div
    aria-hidden={hidden || undefined}
    className="marquee-track flex min-w-full shrink-0 items-center justify-around gap-12 whitespace-nowrap py-1.5"
  >
    {REPEATS.map((i) => (
      <span key={i} className="flex items-center gap-3">
        <TrendingUp className={`h-3.5 w-3.5 ${skin.accent}`} />
        <span
          className={`font-display text-[12px] font-black uppercase tracking-[0.22em] ${skin.text}`}
        >
          {LINE}
        </span>
        <span className={`font-data text-[10px] uppercase tracking-[0.26em] ${skin.accent}`}>
          ongoing drive
        </span>
      </span>
    ))}
  </div>
);

export const MissionTicker = ({ variant = "app" }) => {
  const skin = SKIN[variant] || SKIN.app;
  return (
    <div
      data-testid="mission-ticker"
      title={LINE}
      className={`marquee-wrap no-print flex items-stretch ${skin.wrap}`}
    >
      <span
        className={`flex shrink-0 items-center gap-2 px-3 font-display text-[10px] font-black uppercase tracking-[0.2em] ${skin.badge}`}
      >
        <span className={`mission-flash h-1.5 w-1.5 rounded-full ${skin.dot}`} />
        Mission
      </span>
      <div className="relative flex min-w-0 flex-1 overflow-hidden">
        <Track skin={skin} />
        <Track skin={skin} hidden />
      </div>
    </div>
  );
};
